import { useEffect } from 'react';
import { analytics, events } from 'services/analytics';
import { AnalyticsEventLocation } from 'services/analytics/entities';
import { StyledDialog } from './styled';
import UpsellModalContent from './components/UpsellModalContent/UpsellModalContent';

type PropsType = {
  isOpen: boolean;
  onClose: () => void;
  location: AnalyticsEventLocation;
  songId?: string;
  releaseId?: string;
};

const UpsellModal = ({
  isOpen,
  onClose,
  location,
  songId,
  releaseId,
}: PropsType) => {
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    analytics.track(events.upsellModalTriggered(location));
  }, [isOpen, location]);

  return (
    <StyledDialog open={isOpen} onClose={onClose}>
      <UpsellModalContent
        onClose={onClose}
        songId={songId}
        releaseId={releaseId}
      />
    </StyledDialog>
  );
};

export default UpsellModal;
